import React from 'react';
import { IIconProps } from '../interfaces';

const AleaDockingStationIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '200',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M111.36 98.1701C111.36 98.1701 124.87 93.1001 112.12 82.4301C112.12 82.4301 111.33 81.2001 109.51 82.1101L92.61 91.6701C92.03 91.9901 92.22 92.8701 92.74 93.4501L93.17 93.9401C98.55 98.7001 105.43 100.8 111.36 98.1701Z"
      stroke={color}
      strokeWidth="4"
    />
    <path
      d="M157.709 80.22L157.779 80.17C165.079 74.62 168.139 64.66 161.009 56.32L133.209 27.08C130.629 24.07 126.299 22.84 123.529 24.38L101.509 36.58C98.3892 38.31 98.2092 42.32 101.139 45.49L127.839 75.23C135.859 83.94 150.109 85.99 157.709 80.22Z"
      stroke={color}
      strokeWidth="4"
    />
    <path
      d="M152.451 74.78C160.211 70.84 157.711 63.35 153.211 59.04C153.211 59.04 152.061 57.61 151.101 58.22L133.921 68.42C133.341 68.74 133.301 69.48 133.821 70.06L134.251 70.55C139.631 75.31 146.511 77.41 152.441 74.78H152.451Z"
      stroke={color}
      strokeWidth="4"
    />
    <path
      d="M116.76 104.95L116.84 104.9C124.82 99.98 129.25 90.34 121.68 81.54L93.0798 50.39C90.1298 46.97 85.3099 45.62 82.3399 47.41L58.4098 61.3C55.4398 63.09 55.6499 67.24 58.8399 70.52L85.6698 99.29C93.8698 107.7 108.76 109.88 116.75 104.96L116.76 104.95Z"
      stroke={color}
      strokeWidth="4.04"
    />
    <path
      d="M166.91 90.12L122.4 116.73C109.76 124.28 93.5601 121.94 83.5801 111.1L45.5801 69.82C41.4301 65.32 42.5301 58.13 47.8301 55.06L116.45 15.39C123.13 11.53 131.58 12.75 136.89 18.34L171.72 54.98C181.75 65.53 179.4 82.65 166.91 90.11V90.12Z"
      stroke={color}
      strokeWidth="4.21"
    />
    <path
      d="M43.4806 60.0801L27.7206 89.4601C25.1106 94.3301 26.6006 100.39 31.1706 103.49L72.7406 131.68C84.2006 139.45 99.1106 139.89 111.011 132.81L162.931 101.9C166.181 99.9701 168.701 97.0301 170.131 93.5401L174.601 82.6001"
      stroke={color}
      strokeWidth="4.14"
    />
  </svg>
);

export default AleaDockingStationIcon;
